// Referral code carried by the invite link (/invito/CODE) or the Play install referrer.
const KEY = 'rv_invite_code';
const TTL_MS = 30 * 24 * 3600 * 1000;

export const normalizeInviteCode = (c) => {
  const v = (c || '').toString().trim().toUpperCase();
  return /^[A-Z0-9]{4,8}$/.test(v) ? v : '';
};

export const storeInviteCode = (code) => {
  const c = normalizeInviteCode(code);
  if (!c) return;
  try { localStorage.setItem(KEY, JSON.stringify({ c, t: Date.now() })); } catch { /* noop */ }
};

export const getStoredInviteCode = () => {
  try {
    const raw = JSON.parse(localStorage.getItem(KEY) || 'null');
    if (raw?.c && Date.now() - raw.t < TTL_MS) return raw.c;
  } catch { /* noop */ }
  return '';
};

const PLAY_BASE = 'https://play.google.com/store/apps/details?id=it.rvincente.app.twa';

// Play Store link carrying the code in the install referrer (read back by installReferrer.js)
export const playUrlWithInvite = (code, campaign = 'invita_amici') => {
  const c = normalizeInviteCode(code);
  return c ? `${PLAY_BASE}&referrer=${encodeURIComponent(`utm_source=referral&utm_medium=invite&utm_campaign=${campaign}&ref=${c}`)}` : PLAY_BASE;
};

// Code from a shared link: kept for signup + IP beacon (recovers it after the App Store hop on iPhone)
export const rememberInvite = (code) => {
  const c = normalizeInviteCode(code);
  if (!c) {
    // link with no inviter (e.g. shared by the admin): drop a code its ?ref= may have stored
    try {
      const r = normalizeInviteCode(new URLSearchParams(window.location.search).get('ref'));
      if (r && r === getStoredInviteCode()) localStorage.removeItem(KEY);
    } catch { /* noop */ }
    return;
  }
  storeInviteCode(c);
  try {
    navigator.sendBeacon(`${process.env.REACT_APP_BACKEND_URL}/api/attribution/invite`, JSON.stringify({ code: c }));
  } catch { /* noop */ }
};

// ?ref=CODE on any app link (e.g. a shared match analysis)
export const captureRefParam = () => {
  try {
    const c = new URLSearchParams(window.location.search).get('ref');
    if (c) rememberInvite(c);
  } catch { /* noop */ }
};

// "link" if the code is the one a shared link brought in, "typed" if written by hand
export const inviteCodeSource = (code) => {
  const c = normalizeInviteCode(code);
  if (!c) return undefined;
  return c === getStoredInviteCode() ? 'link' : 'typed';
};
